import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Lock } from '@mui/icons-material'
import { Box } from '@mui/material'

import { GRTooltip } from '../../../../components/GRTooltip/GRTooltip'

type LockedGameIndicatorProps = {
  fontSize?: number | string
}

/**
 * Lock marker for a game outside the user's plan. Shown next to the game name in lists that
 * still list locked games, so the reader knows up front why its links open an unlock dialog.
 */
export const LockedGameIndicator: FC<LockedGameIndicatorProps> = ({ fontSize = 14 }) => {
  const { t } = useTranslation()
  const label = t('live-events:locked_game_tooltip')

  return (
    <GRTooltip content={label} styles={{ cursor: 'help', display: 'inline-flex', flexShrink: 0 }}>
      {/* MUI marks a bare SvgIcon `aria-hidden`, so the label sits on a wrapping image role. */}
      <Box component="span" role="img" aria-label={label} data-testid="locked-game-indicator" sx={{ display: 'inline-flex' }}>
        <Lock aria-hidden sx={{ fontSize, color: 'text.secondary' }} />
      </Box>
    </GRTooltip>
  )
}
